import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-to-top",
  "use": "icon-to-top-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-to-top\"><path d=\"M12.509 8.129L8.366 3.982a.462.462 0 00-.331-.135c-.016-.002-.03-.01-.046-.01a.459.459 0 00-.188.042.455.455 0 00-.16.102L3.903 7.692a.46.46 0 10.652.65L7.527 5.39v8.081a.46.46 0 00.462.459.46.46 0 00.461-.459V5.367l3.403 3.409a.462.462 0 00.79-.322.456.456 0 00-.135-.325zm.553-5.209H2.915a.46.46 0 01-.462-.458.46.46 0 01.462-.46h10.147a.46.46 0 110 .918z\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/to-top.svg
// module id = 515
// module chunks = 4